import React from 'react';

import Lottie from 'react-lottie';

import useAppTheme from '~/hooks/theme';

import animationData from './lottie.json';

import { Container, Content, Message, SubMessage, Back } from './styles';

import { SessionProps } from './interface';

import logoCPLight from '~/assets/logo-light.png';
import logoCPDark from '~/assets/logo-dark.png';

const Session: React.FC<SessionProps> = () => {
  const { currentTheme } = useAppTheme();

  return (
    <Container>
      <Content>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          height={300}
          width={300}
        />

        <img
          src={currentTheme === 'light' ? logoCPLight : logoCPDark}
          alt="Commerceplus"
          title="Commerceplus"
        />
        <Message>Sua sessão expirou!</Message>
        <SubMessage>Faça seu login novamente para continuar</SubMessage>
        <div>
          <Back
            onClick={() =>
              (window.location.href =
                'https://commerceplus.info/auth/#/login?next=https://commerceplus.info/apps/appgestor&app=7')
            }
          >
            REALIZAR LOGIN
          </Back>
        </div>
      </Content>
    </Container>
  );
};

export default Session;
